import { HttpContextToken } from '@angular/common/http';

export enum LogLevel {
    Verbose = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
}

export const LOGGER_REQUEST_NAME = new HttpContextToken<string>(() => '');
